import { modalWatchSagas } from "@onhandtech/onhand-fe-shared/lib/components/modal";
import { firebaseRootSaga } from "@onhandtech/onhand-fe-shared/lib/firebase";
import { all, call } from "redux-saga/effects";

import { campaignsWatchSaga } from "./campaigns/sagas";
import { countriesWatchSaga } from "./countries/sagas";
import { firebaseWatchSagas } from "./firebase/sagas";
import { qrCodesWatchSaga } from "./qr-codes/sagas";
import { bootstrapAuthenticationSaga } from "./sagas/bootstrap-authentication.saga";
import { sectionsWatchSaga } from "./sections/sagas";
import {
	createOrganisation,
	createSession,
	createSignupCode,
	deleteCampaign,
	deleteCampaignPermission,
	deleteRequestFilterSets,
	getCampaign,
	getRequestFilterSets,
	getV4TaskTypes,
	patchRequest,
	patchRequestFilterSets,
	postCampaign,
	postCampaignPermission,
	postFile,
	postRequestFilterSets,
	requestFilterDeletePermissions,
	requestFilterSetPermissions,
	requests,
	signUpCodes,
	signUpCodesDetails,
	taskTypes,
	users,
	volunteerGroup,
} from "./redux-modules";
import { missionsWatchSaga } from "./ayom/missions/sagas";
import { setFeaturesSaga } from "./features/sagas/set-features.saga";

function* rootSaga() {
	yield all([
		call(setFeaturesSaga),
		call(createSession.rootSaga, createSession.slice.name),
		call(signUpCodes.rootSaga, signUpCodes.slice.name),
		call(
			signUpCodesDetails.rootSaga,
			signUpCodesDetails.slice.name,
			signUpCodesDetails.additionalSagas,
		),
		call(
			createSignupCode.rootSaga,
			createSignupCode.slice.name,
			createSignupCode.additionalSagas,
		),
		call(volunteerGroup.rootSaga, volunteerGroup.slice.name),
		call(taskTypes.rootSaga, taskTypes.slice.name),
		call(getV4TaskTypes.rootSaga, getV4TaskTypes.slice.name),
		call(requests.rootSaga, requests.slice.name, requests.additionalSagas),
		call(
			patchRequest.rootSaga,
			patchRequest.slice.name,
			patchRequest.additionalSagas,
		),
		call(
			getRequestFilterSets.rootSaga,
			getRequestFilterSets.slice.name,
			undefined,
			"takeEvery",
		),
		call(patchRequestFilterSets.rootSaga, patchRequestFilterSets.slice.name),
		call(deleteRequestFilterSets.rootSaga, deleteRequestFilterSets.slice.name),
		call(postRequestFilterSets.rootSaga, postRequestFilterSets.slice.name),
		call(
			requestFilterSetPermissions.rootSaga,
			requestFilterSetPermissions.slice.name,
		),
		call(
			requestFilterDeletePermissions.rootSaga,
			requestFilterDeletePermissions.slice.name,
			undefined,
			"takeEvery",
		),
		call(postCampaignPermission.rootSaga, postCampaignPermission.slice.name),
		call(
			deleteCampaignPermission.rootSaga,
			deleteCampaignPermission.slice.name,
			undefined,
			"takeEvery",
		),
		call(users.rootSaga, users.slice.name),
		call(postFile.rootSaga, postFile.slice.name),
		call(
			createOrganisation.rootSaga,
			createOrganisation.slice.name,
			createOrganisation.additionalSagas,
		),
		call(firebaseRootSaga),
		call(firebaseWatchSagas),
		call(qrCodesWatchSaga),
		call(modalWatchSagas),
		call(bootstrapAuthenticationSaga),
		call(missionsWatchSaga),
		call(sectionsWatchSaga),
		call(countriesWatchSaga),
		call(campaignsWatchSaga),
		call(getCampaign.rootSaga, getCampaign.slice.name, undefined, "takeEvery"),
		call(postCampaign.rootSaga, postCampaign.slice.name),
		call(deleteCampaign.rootSaga, deleteCampaign.slice.name),
	]);
}

export default rootSaga;
